import { Component, ViewEncapsulation } from '@angular/core';

import { ToastNotification, ToastNotificationService } from '../../services/toast-notification.service';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-toast-notifications',
  styleUrls: ['./toast-notifications.component.scss'],
  templateUrl: './toast-notifications.component.html',
  standalone: false
})
export class ToastNotificationsComponent {
  notifications: ToastNotification[];

  types = {
    critical: {
      icon: 'circle-alert',
      color: 'var(--color-system-critical-2)'
    },
    success: {
      icon: 'circle-check-big',
      color: 'var(--color-system-success-2)'
    },
    info: {
      icon: 'info',
      color: 'var(--color-system-info-2)'
    },
    warning: {
      icon: 'triangle-alert',
      color: 'var(--color-system-warning-2)'
    }
  };

  constructor(private toastNotificationService: ToastNotificationService) {
    this.toastNotificationService.notifications$.subscribe((notifications) => {
      this.notifications = notifications;
    });
  }
}
